import { Controller } from "@hotwired/stimulus"
import consumer from "../../channels/consumer"

// Connects to data-controller="chat-input"
export default class extends Controller {
  static values = {
    conversationId: Number,
    userId: Number,       // Devise current_user.id
    displayName: String   // Devise current_user.display_name
  }
  static targets = ["input"]

  connect() {
    this.channel = consumer.subscriptions.create(
      { channel: "ChatChannel", conversation_id: this.conversationIdValue },
      { received: () => { } }
    )
    this.typing = false
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.stopTyping()
  }

  input() {
    if (!this.typing) {
      this.typing = true
      this.channel.send({
        action: "typing",
        typing: true
      })
    }

    clearTimeout(this.timeout)
    this.timeout = setTimeout(this.stopTyping.bind(this), 1000)
  }

  stopTyping() {
    this.typing = false
    this.channel.send({
      action: "typing",
      typing: false
    })
  }
}
